/**
 * The length of each item part in the uid generation flow
 * @type {Number}
 */
const UID_PART_LENGTH = 8;

module.exports = {
    UID_PART_LENGTH
};
